import { IIconProps } from "./add"


export const IcoArrowUpDown = ({style={}, cy}: IIconProps) => {
  return (
    <svg width="12" style={style} height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" data-cy={`IconArrowUpDown${cy}`}>
    <path d="M5.33333 12H0V6.66667H1.33333V9.72667L9.72667 1.33333H6.66667V0H12V5.33333H10.6667V2.27333L2.27333 10.6667H5.33333V12Z" fill="#793EAD"/>
    </svg>

  )
}